export const environment = {
  production: true,
  superadminUsername: 'superadmin',
  superadminPassword: 'superadmin',
  pushNotificationUrl: 'https://paymenthqvm.stagingpaymenthq.com:8090',
  apiRoot: 'https://api.hfspadmin.com/',
  privacyPolicyLink: 'https://www.heartland.us/privacy-policy',
  termsOfUseUrl: 'https://www.heartland.us/terms',
  cashjarApi: 'https://cashjarv2-api.azurewebsites.net/',
};
